import { useAppStore } from '@/store/modules/app.ts'

// 字体变更
export function changeTextSizeFn(size) {
  const appStore = useAppStore()
  const sizeMap = {
    'large': { large: '22px', middle: '20px', default: '18px', small: '16px' },
    'middle': { large: '20px', middle: '18px', default: '16px', small: '14px' },
    'default': {
      large: '18px',
      middle: '16px',
      default: '14px',
      small: '12px',
    },
  }

  const sizes = sizeMap[size]
  if (!sizes) return // 无效输入处理

  document.documentElement.style.setProperty('--font-size-large', sizes.large)
  document.documentElement.style.setProperty('--font-size-middle', sizes.middle)
  document.documentElement.style.setProperty(
    '--font-size-default',
    sizes.default
  )
  document.documentElement.style.setProperty('--font-size-small', sizes.small)
  appStore.setSize(size)
}
// 主题变更
export function changeColorFn(color) {
  const appStore = useAppStore()
  const colorMap = {
    'green': '#28be9b',
    'blue': '#1b85ff',
    'purple': '#8d69d4',
    'yellow': '#ffb43c',
    'brown': '#b18056',
  }
  const colorRgb = {
    'green': '40,190,155',
    'blue': '27,133,255',
    'purple': '141,105,212',
    'yellow': '255,180,60',
    'brown': '177,128,86',
  }
  const colorLightMap = {
    'green': '#dff5f0',
    'blue': '#e5eeff',
    'purple': '#eee9f9',
    'yellow': '#fff4e2',
    'brown': '#f4ece6',
  }

  const selectedColor = colorMap[color]
  const selectedLightColor = colorLightMap[color]
  const selectedRgbColor = colorRgb[color]
  if (selectedColor) {
    document.documentElement.style.setProperty('--brown', selectedColor)
    document.documentElement.style.setProperty(
      '--light-brown',
      selectedLightColor
    )
    document.documentElement.style.setProperty(
      '--primary-rgb',
      selectedRgbColor
    )
    appStore.setTheme(color)
  }
}
